<div class="row row-sm">
    <div class="col-lg-12">
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="bc d-flex align-items-center pl-3" *ngIf="submitButton">
                        <img alt="Logo" src="../../assets/img/DivisionMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                            <div>
                                <h3 class="main-content-label mb-0"><b>
                                        Eligibility
                                    </b></h3>
                                <p class="text-muted card-sub-title mb-0">
                                    Add New Eligibility Criteria
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="bc d-flex align-items-center pl-3" *ngIf="editButton">
                        <img alt="Logo" src="../../assets/img/DivisionMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                            <div>
                                <h3 class="main-content-label mb-0"><b>
                                        Eligibility
                                    </b></h3>
                                <p class="text-muted card-sub-title mb-0">
                                    Update Eligibility Criteria
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="bc d-flex align-items-center pl-3" *ngIf="deleteButton">
                        <img alt="Logo" src="../../assets/img/DivisionMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                            <div>
                                <h3 class="main-content-label mb-0"><b>
                                        Eligibility
                                    </b></h3>
                                <p class="text-muted card-sub-title mb-0">
                                    Delete Eligibility Criteria
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <hr class="mt-3">
                <div class="row row-sm add-form">
                    <form autocomplete="off" class="p-0" [formGroup]="eligiblityForm " novalidate>
                        <div class="col-lg-12 col-md-12">
                            <div class="row clearfix ">
                                <div class="col-sm-3">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Session</mat-label>
                                        <mat-select #select232 placeholder="Session" class="colorblack"
                                            formControlName="SessionID" required>
                                            <mat-select-filter *ngIf="select232.focused" [placeholder]="'Filter'"
                                                [displayMember]="'SnName'" [array]="sessionList"
                                                (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                            <mat-option *ngFor="let item of SessionFilterList" [value]="item.SnNo">
                                                {{item.SnName}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group1">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Faculty</mat-label>
                                                <mat-select  required #select33 placeholder=""
                                                    class="colorblack" formControlName="Faculty">
                                                    <mat-select-filter *ngIf="select33.focused" [placeholder]="'Filter'"
                                                        [displayMember]="'FcDesc'" [array]="fcCodeList"
                                                        (filteredReturn)="filteredListFcCode =$event">
                                                    </mat-select-filter>
                                                    <mat-option *ngFor="let item of filteredListFcCode"
                                                        [value]="item.FcCode" (click)="getCourseData(item.FcCode)">
                                                        {{item.FcCode}} - {{item.FcDesc}}
                                                    </mat-option>
                                                </mat-select>
                                                <!-- <mat-error class="margin_tp"
                          *ngIf="feeMappingForm.controls['Faculty'].touched && feeMappingForm.controls['Faculty'].errors?.required">
                          Mandatory
                        </mat-error> -->
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group1">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>Course</mat-label>
                                                <mat-select required #select36 placeholder="" class="colorblack"
                                                    formControlName="CoCode">
                                                    <mat-select-filter *ngIf="select36.focused" [placeholder]="'Filter'"
                                                        [displayMember]="'CoName'" [array]="courseList"
                                                        (filteredReturn)="filteredCourseList =$event">
                                                    </mat-select-filter>
                                                    <mat-option *ngFor="let item of filteredCourseList"
                                                         [value]="item.CoCode">
                                                        {{item.CoCode}} - {{item.CoName}}
                                                    </mat-option>
                                                </mat-select>
                                                <!-- <mat-error class="margin_tp"
                          *ngIf="feeMappingForm.controls['Course'].touched && feeMappingForm.controls['Course'].errors?.required">
                          Mandatory
                        </mat-error> -->
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <mat-form-field appearance="outline" class="example-full-width">
                                        <mat-label>Designation</mat-label>
                                        <mat-select formControlName="Designation" #select3904 placeholder="Request Type"
                                            class="colorblack">
                                            <mat-select-filter *ngIf="select3904.focused" [placeholder]="'Request Type'"
                                                [displayMember]="'CdDesc'" [array]="requestTypeList"
                                                (filteredReturn)="filteredrequestTypeList =$event">
                                            </mat-select-filter>
                                            <mat-option *ngFor="let item of filteredrequestTypeList"
                                                [value]="item.CdCode">
                                                {{item.CdDesc}}
                                            </mat-option>
                                        </mat-select>
                                        <!-- <mat-error class="margin_tp"
                                *ngIf="teacherAssignForm.controls['ReqType'].touched && teacherAssignForm.controls['ReqType'].errors?.required">
                                Mandatory
                            </mat-error> -->
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    Experience
                                                </mat-label>
                                                <input onkeydown="return (event.keyCode!=13);" style="color:black;"
                                                    type="text" maxlength="2" placeholder=""
                                                    formControlName="Experience" matInput required>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                 <div class="col-sm-3">
                        <div class="form-group1">
                          <div class="">
                            <mat-form-field appearance="outline" class="example-full-width">
                              <mat-label>
                                Course Level
                              </mat-label>
                              <mat-select #select22 class="colorblack" formControlName="CoLevel">
                                <mat-select-filter *ngIf="select22.focused" [placeholder]="'Filter'"
                                  [displayMember]="'CdDesc'" [array]="courseLevelList"
                                  (filteredReturn)="filteredcourseLevelList =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredcourseLevelList" [value]="item.CdCode">
                                  {{item.CdDesc}}
                                </mat-option>
                              </mat-select>
                              <!-- <mat-error class="margin_tp"
                                *ngIf="courseForm.controls['CoLevel'].touched && courseForm.controls['CoLevel'].errors?.required">
                                Mandatory
                              </mat-error> -->
                            </mat-form-field>
                          </div>
                        </div>
                      </div>
                                 <div class="col-sm-12 row ">
                        <div class="col-sm-12 prpl">
                          <button id="Save" type="button" *ngIf="submitButton"
                            class="btn fr sz btn-primary btn-icon-text floatright mt-1" (click)="submitMarkAsTouched()">
                            <span style="display: contents; align-items: center;">
                              <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                              {{'header.course-data.titleList.Save'| translate }} 
                            </span>
                          </button>
                          <button id="Update" type="button" *ngIf="editButton"
                            class="btn fr sz btn-primary btn-icon-text floatright mt-1" (click)="updateMarkAsTouched()">
                            <span style="display: contents; align-items: center;">
                              <img width="20vh" src="../../assets/img/edit1.gif" style="margin-right: 5px;">
                              {{'header.course-data.titleList.Update'| translate }}   
                            </span>
                          </button>
                          <button id="Delete" type="button" *ngIf="deleteButton"
                            class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                            (click)="openConformationModalBox()">
                            <span style="display: contents; align-items: center;">
                              <img width="23%" src="../../assets/img/trash.gif" style="margin-right: 5px;">
                              {{'header.course-data.titleList.Delete'| translate }} 
                            </span>
                          </button>
                          <button id="Back" type="button" [mat-dialog-close]="true"
                            class="btn fr sz btn-primary btn-icon-text floatright mr-3 mt-1">
                            <span style="display: contents; align-items: center; margin-left:1rem;">
                              <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                              {{'header.course-data.titleList.Back'| translate }} 
                            </span>
                          </button>
                        </div>

                      </div>

                                <!-- <div class="row prpl">
                                    <div class="col-sm-12">
                                        <button id="Back" type="button" [mat-dialog-close]="true"
                                            class="btn btn-primary fr sz btn-icon-text floatright mt-1 ">
                                            <span style="display: contents; align-items: center;">
                                                <img width="25%" src="../../assets/img/turn-left.gif"
                                                    style="margin-right: 5px ;">
                                                {{'header.division-data.table.Back' | translate}}
                                            </span>
                                        </button>
                                    </div>

                                </div> -->
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>